import CollectDevice from './CollectDevice'
export default CollectDevice
